export const blogPosts = [
  {
    id: "programming-tips",
    title: "Programming Learning Tips",
    image:
      "https://images.unsplash.com/photo-1516116218213-ff8a9dbb2c86?auto=format&fit=crop&w=600&q=80",
    excerpt:
      "Essential strategies to accelerate your software engineering journey, from mastering clean code to understanding complex system architecture.",
    date: "July 2024",
    readTime: "5 min read",
    link: "#",
  },
  {
    id: "gmmk-pro-review",
    title: "Review Keyboard GMMK Pro",
    image:
      "https://images.unsplash.com/photo-1587829741301-dc798b83add3?auto=format&fit=crop&w=600&q=80",
    excerpt:
      "Deep technical breakdown of custom mechanical keyboards, switch ergonomics, and how hardware choices impact developer productivity.",
    date: "June 2024",
    readTime: "7 min read",
    link: "#",
  },
  {
    id: "enjoying-coffee",
    title: "Enjoying a Cup of Coffee & Code",
    image:
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=600&q=80",
    excerpt:
      "Balancing deep focus sessions with proper breaks. Exploring how mental resets and caffeine rituals enhance problem-solving flow.",
    date: "May 2024",
    readTime: "4 min read",
    link: "#",
  },
];
